import { GET_USERS_SUCCESS, CREATE_USER_SUCCESS, EDIT_USER_SUCCESS } from './user.types';

const initialState = { users: [] };

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return { ...state, users: action.payload };
    case CREATE_USER_SUCCESS:
      return { ...state, users: [...state.users, action.payload] };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map((u) => (u._id === action.payload._id ? action.payload : u)),
      };
    default:
      return state;
  }
};
